<template>
  <div class="pdb-pair-viewer">
    <div v-if="failed" role="alert" class="alert alert-warning">
      DDM calculation for {{ pair.pdbInfo1.name }}, {{ pair.pdbInfo2.name }}
      failed. Please try later.
    </div>

    <div v-else>
      <div class="p-3">
        <h5>
          <span v-if="!pair"
            >Select pair for comparison by clicking on comparison matrix</span
          >
          <span v-else>
            <span v-if="loading">Building animation for:</span>
            <span v-if="!loading">Selected pair:</span>
            {{ pair.pdbInfo1.name }}, {{ pair.pdbInfo2.name }}
          </span>
        </h5>
      </div>

      <div v-if="loading && pair">
        <i class="fa fa-4x fa-spinner fa-spin m-2"></i>
      </div>
      <div v-if="!loading && pair && ddmURL" class="row ml-3 mb-2">
        <div class="col-12">
          <button
            type="button"
            class="btn btn-sm btn-primary mr-1"
            v-bind:class="{ 'btn-info': traj === 1 }"
            v-on:click="showMovie(1)"
          >
            Trajectory 1
          </button>
          <button
            type="button"
            class="btn btn-sm btn-primary mr-1"
            v-bind:class="{ 'btn-info': traj === 2 }"
            v-on:click="showMovie(2)"
          >
            Trajectory 2
          </button>
          <button
            type="button"
            class="btn btn-sm btn-primary mr-1"
            v-bind:class="{ 'btn-info': traj === 3 }"
            v-on:click="showMovie(3)"
          >
            Trajectory 3
          </button>
          <button
            type="button"
            class="btn btn-sm btn-primary mr-1"
            v-bind:class="{ 'btn-info': traj === 0 }"
            v-on:click="showMovie()"
          >
            Animation
          </button>
        </div>
      </div>
      <div id="container3d" class="mol-container"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PDBPairViewer",
  props: {
    pair: Object,
  },
  watch: {
    pair: {
      deep: false,
      handler() {
        this.failed = false;
        this.$nextTick(function () {
          this.getDdmPDBUrl();
        });
      },
    },
    ddmURL: {
      handler() {
        if (!this.failed) this.showMovie(1);
      },
    },
  },
  data: function () {
    return {
      loading: Boolean,
      ddmURL: String,
      traj: 0,
      failed: false,
    };
  },
  mounted() {
    const self = this;
    window.onresize = function () {
      self.updateContainerSize();
    };
  },
  methods: {
    log: function (msg) {
      console.log(`PDBPairViewer: ${msg}`);
    },
    getDdmPDBUrl: async function () {
      const self = this;
      self.ddmURL = null;
      self.loading = true;

      window.jQuery("#container3d").empty();
      window.jQuery("#container3d").height(0);

      if (this.pair.ddmURL) {
        // precalculated results
        this.log(" using precalculated results");
        this.ddmURL = this.pair.ddmURL;
        this.loading = false;
      } else {
        if (this.pair.pdbInfo1.name && this.pair.pdbInfo2.name) {
          this.$dataService.runDDM(this.pair, "modflex.job", self);
        }
      }
    },
    showMovie(trajectory) {
      this.traj = trajectory || 0;
      if (!this.ddmURL) return;

      window.jQuery("#container3d").empty();
      window.jQuery("#container3d").height(0);
      this.updateContainerSize();

      if (trajectory)
        window.displayTrajectory(this.ddmURL, "container3d", trajectory);
      else window.displayAnimation(this.ddmURL, "container3d");
    },
    updateContainerSize() {
      const width = this.getWidth();
      window.jQuery("#container3d").width(width);
      window.jQuery("#container3d").height(width);
    },
    getWidth() {
      let W = window.jQuery("#pairwiseSection").innerWidth() || 300;
      return W;
    },
  },
};
</script>

<style scoped>
.mol-container {
  /* width: 500px;*/
  /* height: 500px;  */
  position: relative;
}
</style>
